import Namespace from './type/Namespace';
import { Message } from './type/Message';

type T = (id: string) => Message;

const f: T = (id) => {
    return {
        namespace: Namespace.SHARE_LINKS_CLIENT,
        action: 'url-match',
        payload: {
            id,
        },
    };
};

export default f;
